/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Tenant} from '../bioplanModels';
// @ts-ignore
import type {WriteTenant} from '../bioplanModels';
/**
 * OrganisationTenantApi - axios parameter creator
 * @export
 */
export const OrganisationTenantApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tenants/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create tenant
     * @param {WriteTenant} writeTenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsPost: async (writeTenant: WriteTenant, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writeTenant' is not null or undefined
      assertParamExists('tenantsPost', 'writeTenant', writeTenant);
      const localVarPath = `/tenants/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeTenant, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete tenant by its identifier
     * @param {string} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdDelete: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'tenantId' is not null or undefined
      assertParamExists('tenantsTenantIdDelete', 'tenantId', tenantId);
      const localVarPath = `/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get tenant by its identifier
     * @param {string} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdGet: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'tenantId' is not null or undefined
      assertParamExists('tenantsTenantIdGet', 'tenantId', tenantId);
      const localVarPath = `/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update tenant
     * @param {string} tenantId
     * @param {Tenant} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdPut: async (
      tenantId: string,
      tenant: Tenant,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'tenantId' is not null or undefined
      assertParamExists('tenantsTenantIdPut', 'tenantId', tenantId);
      // verify required parameter 'tenant' is not null or undefined
      assertParamExists('tenantsTenantIdPut', 'tenant', tenant);
      const localVarPath = `/tenants/{tenantId}`.replace(`{${'tenantId'}}`, encodeURIComponent(String(tenantId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(tenant, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrganisationTenantApi - functional programming interface
 * @export
 */
export const OrganisationTenantApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrganisationTenantApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tenant>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationTenantApi.tenantsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create tenant
     * @param {WriteTenant} writeTenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsPost(
      writeTenant: WriteTenant,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsPost(writeTenant, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationTenantApi.tenantsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete tenant by its identifier
     * @param {string} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsTenantIdDelete(
      tenantId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsTenantIdDelete(tenantId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationTenantApi.tenantsTenantIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get tenant by its identifier
     * @param {string} tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsTenantIdGet(
      tenantId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsTenantIdGet(tenantId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationTenantApi.tenantsTenantIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update tenant
     * @param {string} tenantId
     * @param {Tenant} tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsTenantIdPut(
      tenantId: string,
      tenant: Tenant,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsTenantIdPut(tenantId, tenant, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationTenantApi.tenantsTenantIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OrganisationTenantApi - factory interface
 * @export
 */
export const OrganisationTenantApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OrganisationTenantApiFp(configuration);
  return {
    /**
     *
     * @summary Get all tenants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Tenant>> {
      return localVarFp.tenantsGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create tenant
     * @param {OrganisationTenantApiTenantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsPost(
      requestParameters: OrganisationTenantApiTenantsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Tenant> {
      return localVarFp.tenantsPost(requestParameters.writeTenant, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete tenant by its identifier
     * @param {OrganisationTenantApiTenantsTenantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdDelete(
      requestParameters: OrganisationTenantApiTenantsTenantIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .tenantsTenantIdDelete(requestParameters.tenantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get tenant by its identifier
     * @param {OrganisationTenantApiTenantsTenantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdGet(
      requestParameters: OrganisationTenantApiTenantsTenantIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Tenant> {
      return localVarFp
        .tenantsTenantIdGet(requestParameters.tenantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update tenant
     * @param {OrganisationTenantApiTenantsTenantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsTenantIdPut(
      requestParameters: OrganisationTenantApiTenantsTenantIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Tenant> {
      return localVarFp
        .tenantsTenantIdPut(requestParameters.tenantId, requestParameters.tenant, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for tenantsPost operation in OrganisationTenantApi.
 * @export
 * @interface OrganisationTenantApiTenantsPostRequest
 */
export interface OrganisationTenantApiTenantsPostRequest {
  /**
   *
   * @type {WriteTenant}
   * @memberof OrganisationTenantApiTenantsPost
   */
  readonly writeTenant: WriteTenant;
}

/**
 * Request parameters for tenantsTenantIdDelete operation in OrganisationTenantApi.
 * @export
 * @interface OrganisationTenantApiTenantsTenantIdDeleteRequest
 */
export interface OrganisationTenantApiTenantsTenantIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationTenantApiTenantsTenantIdDelete
   */
  readonly tenantId: string;
}

/**
 * Request parameters for tenantsTenantIdGet operation in OrganisationTenantApi.
 * @export
 * @interface OrganisationTenantApiTenantsTenantIdGetRequest
 */
export interface OrganisationTenantApiTenantsTenantIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationTenantApiTenantsTenantIdGet
   */
  readonly tenantId: string;
}

/**
 * Request parameters for tenantsTenantIdPut operation in OrganisationTenantApi.
 * @export
 * @interface OrganisationTenantApiTenantsTenantIdPutRequest
 */
export interface OrganisationTenantApiTenantsTenantIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationTenantApiTenantsTenantIdPut
   */
  readonly tenantId: string;

  /**
   *
   * @type {Tenant}
   * @memberof OrganisationTenantApiTenantsTenantIdPut
   */
  readonly tenant: Tenant;
}

/**
 * OrganisationTenantApi - object-oriented interface
 * @export
 * @class OrganisationTenantApi
 * @extends {BaseAPI}
 */
export class OrganisationTenantApi extends BaseAPI {
  /**
   *
   * @summary Get all tenants
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationTenantApi
   */
  public tenantsGet(options?: RawAxiosRequestConfig) {
    return OrganisationTenantApiFp(this.configuration)
      .tenantsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create tenant
   * @param {OrganisationTenantApiTenantsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationTenantApi
   */
  public tenantsPost(requestParameters: OrganisationTenantApiTenantsPostRequest, options?: RawAxiosRequestConfig) {
    return OrganisationTenantApiFp(this.configuration)
      .tenantsPost(requestParameters.writeTenant, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete tenant by its identifier
   * @param {OrganisationTenantApiTenantsTenantIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationTenantApi
   */
  public tenantsTenantIdDelete(
    requestParameters: OrganisationTenantApiTenantsTenantIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationTenantApiFp(this.configuration)
      .tenantsTenantIdDelete(requestParameters.tenantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get tenant by its identifier
   * @param {OrganisationTenantApiTenantsTenantIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationTenantApi
   */
  public tenantsTenantIdGet(
    requestParameters: OrganisationTenantApiTenantsTenantIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationTenantApiFp(this.configuration)
      .tenantsTenantIdGet(requestParameters.tenantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update tenant
   * @param {OrganisationTenantApiTenantsTenantIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationTenantApi
   */
  public tenantsTenantIdPut(
    requestParameters: OrganisationTenantApiTenantsTenantIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationTenantApiFp(this.configuration)
      .tenantsTenantIdPut(requestParameters.tenantId, requestParameters.tenant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
